import { registerLocaleData } from '@angular/common';
import localeES from '@angular/common/locales/es-CO';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql.module';
import { RequestInterceptorService } from './interceptors/request-interceptor.service';
import { AuthModule } from './modules/auth/auth.module';
import { ProyectosModule } from './modules/recursos/components/proyectos/proyectos.module';
import { AuthService } from './services/auth.service';
import { CoreService } from './services/core.service';
import { CommonService } from './services/common.service';
import { GagemService } from './services/gagem.service';
import { InstitutionsGatewayService } from './services/institutions.service';
import { LocalStorageService } from './services/local-storage.service';
import { documentsReducer } from './shared/state/reducers/documents.reducer';
import { globalReducer } from './shared/state/reducers/global.reducer';
import { LayoutModule } from './theme/layout/layout.module';

registerLocaleData(localeES);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		RouterModule.forRoot([]),
		AuthModule,
		LayoutModule,
		HttpClientModule,
		StoreModule.forRoot({ documents: documentsReducer, global: globalReducer }),
		ProyectosModule,
		GraphQLModule
	],
	providers: [
		{
			provide: LOCALE_ID,
			useValue: 'es-CO'
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestInterceptorService, // Clase interceptor
			multi: true // Pendiente de todas las peticiones.
		},
		AuthService,
		LocalStorageService,
		CoreService,
		CommonService,
		GagemService,
		InstitutionsGatewayService
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
